import React, { useEffect, useState } from 'react';
import { Grid, Skeleton, Alert, Link } from '@mui/material';
import Chart from 'react-apexcharts';
import axios from 'src/utils/axios';
import { is } from 'date-fns/locale';
import { useTheme } from '@mui/material/styles';

const today = new Date();
const lastYear = today.getFullYear() - 1
const thisYear = today.getFullYear()


const todayString = today.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
const lastYearString = new Date(lastYear, today.getMonth(), today.getDate()).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });

const tempData = [
    {
        "RANDEVUYA_UYUM_PUANI": 0,
        "YEAR": lastYear,
        "DATE": lastYearString,
        "Period": "LastYear"
    },
    {
        "RANDEVUYA_UYUM_PUANI": 0,
        "YEAR": thisYear,
        "DATE": todayString,
        "Period": "ThisYear"
    }
]

const ServiceAppointmentConformity = ({ ServiceShopId, EmployeeRole }) => {
    const [data, setData] = useState(tempData);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();

    useEffect(() => {
        axios.get(`GetServiceAppointmentConformity/${ServiceShopId}`).then((response) => {
            if (response) {
                if (response.data.length > 0) {
                    setData(response.data);
                }
                else {
                    setData(tempData);
                }

            }
            setLoading(false);
        });
    }, [ServiceShopId]);

    const ServiceAppointmentConformityData = {
        series: [
            {
                name: 'ServiceAppointmentConformity',
                data: data.map((item) => item.RANDEVUYA_UYUM_PUANI),
                type: 'column'
            }
        ],
        options: {
            chart: {
                type: 'bar',
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }
            },
            xaxis: {
                categories: data.map((item) => [`01 Ocak ${item.YEAR}`, '-', `${item.DATE}`]),
            },
            yaxis: {
                title: {
                    text: 'RandevuyaUyumPuanı'
                }
            },
            title: {
                text: 'Yıllık Randevuya Uyum Puanları'
            },
            colors: ['#008FFB'], // Sütun rengi
        }
    };

    const serviceAppointmentConformityIncrease = (((ServiceAppointmentConformityData.series[0].data[1] - ServiceAppointmentConformityData.series[0].data[0]) / ServiceAppointmentConformityData.series[0].data[0]) * 100).toFixed(1);
    const isPositive = serviceAppointmentConformityIncrease >= 0;
    const chartTitle = isPositive ? 'Artış Oranı' : 'Azalış Oranı';
    const chartColor = isPositive ? '#2e7d32' : '#d32f2f';

    const ServiceAppointmentConformityPercentageData = {
        series: [Math.abs(serviceAppointmentConformityIncrease)],
        chart: {
            height: 350,
            type: 'radialBar',
            offsetY: -10
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                        fontSize: '16px',
                        color: chartColor,
                        offsetY: 76
                    },
                    value: {
                        offsetY: 92,
                        fontSize: '22px',
                        formatter: function (val) {
                            return val + "%";
                        }
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                shadeIntensity: 0.15,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 50, 65, 91]
            },
        },
        stroke: {
            dashArray: 4
        },
        //labels isPositive ? ['Artış Oranı'] : ['Azalış Oranı'],
        labels: [chartTitle],
        colors: [chartColor],
    };

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={8} >
                    {loading ? (
                        <Skeleton variant="rectangular" height={350} width={'100%'} />
                    ) : (
                        <Chart
                            options={ServiceAppointmentConformityData.options}
                            series={ServiceAppointmentConformityData.series}
                            type="bar"
                            height={350}
                        />
                    )}
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={280} width={'100%'} />
                    ) : (
                        <Chart
                            options={ServiceAppointmentConformityPercentageData}
                            series={ServiceAppointmentConformityPercentageData.series}
                            type="radialBar"
                            height={280}
                        />
                    )}
                </Grid>
                <Grid item xs={12}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={100} />
                    ) : (
                        (EmployeeRole === 1 || EmployeeRole === 2) && (
                            <Alert
                                variant="outlined"
                                severity="info"
                                sx={{
                                    borderColor: theme.palette.info.dark,
                                    fontSize: '12px',
                                    fontFamily: 'Helvetica, Arial, sans-serif'
                                }}>
                                Detaylı kırılımlarda görüntülemek için Atlas dashboardlardan faydalanabilirsiniz.
                                <br />
                                <Link
                                    href="https://atlas.beko.com/okta/sense/app/48e84271-abbf-4c9e-8241-2782a507dbec/sheet/bae4d0ef-61d6-45c9-97e6-f6b976edd8dc/state/analysis"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    İlgili Atlas dashboardundan faydalanmak için tıklayınız.
                                </Link>
                            </Alert>
                        )
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

export default ServiceAppointmentConformity;
